import { render, staticRenderFns } from "./ProductizeUseCaseCreate.vue?vue&type=template&id=3643efd6&scoped=true"
import script from "./ProductizeUseCaseCreate.vue?vue&type=script&lang=js"
export * from "./ProductizeUseCaseCreate.vue?vue&type=script&lang=js"
import style0 from "./ProductizeUseCaseCreate.vue?vue&type=style&index=0&id=3643efd6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643efd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3643efd6')) {
      api.createRecord('3643efd6', component.options)
    } else {
      api.reload('3643efd6', component.options)
    }
    module.hot.accept("./ProductizeUseCaseCreate.vue?vue&type=template&id=3643efd6&scoped=true", function () {
      api.rerender('3643efd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/ProductizeUseCaseCreate.vue"
export default component.exports